import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, int32_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class SubproductDefinitionDTO extends Record {
    constructor(Name, ProductNr, TypeOfSubproduct, Parameter, SortOrder) {
        super();
        this.Name = Name;
        this.ProductNr = (ProductNr | 0);
        this.TypeOfSubproduct = TypeOfSubproduct;
        this.Parameter = Parameter;
        this.SortOrder = (SortOrder | 0);
    }
}

export function SubproductDefinitionDTO$reflection() {
    return record_type("Containers.SubproductDefinition.Model.SubproductDefinitionDTO", [], SubproductDefinitionDTO, () => [["Name", string_type], ["ProductNr", int32_type], ["TypeOfSubproduct", string_type], ["Parameter", string_type], ["SortOrder", int32_type]]);
}

export class SubproductDefinition extends Record {
    constructor(Id, DTO) {
        super();
        this.Id = Id;
        this.DTO = DTO;
    }
}

export function SubproductDefinition$reflection() {
    return record_type("Containers.SubproductDefinition.Model.SubproductDefinition", [], SubproductDefinition, () => [["Id", string_type], ["DTO", SubproductDefinitionDTO$reflection()]]);
}

